var React = require('react');

function BlueHeart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M96.67,15.85c-0.07,0-0.13,0-0.2,0c-0.49,0-0.99,0-1.48,0.02c-5.18,0.09-10.21,1.24-14.96,3.23 c-5.09,2.15-8.58,5.35-13.11,8.23c-0.85,0.54-1.89,0.81-2.92,0.81c-1.04,0-2.08-0.27-2.93-0.81c-4.52-2.88-8.02-6.08-13.11-8.23 c-4.75-1.99-9.78-3.14-14.96-3.23c-0.49-0.02-0.98-0.02-1.47-0.02c-0.07,0-0.13,0-0.2,0c-13.12,0-22.69,7.54-28.3,20.65 c-2.4,5.58-2.44,13.98-1.46,19.84c0.98,5.84,3.41,11.11,6.72,16.03C19.32,88.8,39,96.42,53.19,109.66 c1.51,1.41,3.01,2.94,4.55,4.35c1.64,1.51,3.62,4.99,6.26,5.15c2.63-0.16,4.62-3.63,6.26-5.15c1.54-1.42,3.03-2.94,4.55-4.35 C89,96.42,108.67,88.8,119.7,72.38c3.31-4.92,5.74-10.19,6.72-16.03c0.98-5.86,0.94-14.27-1.46-19.84 C119.35,23.39,109.79,15.85,96.67,15.85L96.67,15.85z"}));
}

BlueHeart.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = BlueHeart;

BlueHeart.default = BlueHeart;
